import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'landing-holiday',
  templateUrl: './landing-holiday.component.html',
  styleUrls: ['./landing-holiday.component.scss']
})
export class LandingHolidayComponent implements OnInit {
  public isLoaded = false;
  public isGenericDetail;

  constructor(
    private _route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.isGenericDetail = this._route.snapshot['_urlSegment'].segments.length < 6;
    this.isLoaded = true;
  }

}
